export default __webpack_public_path__ + "static/media/down-arrow.7b77c5ba.svg";